import axios from 'axios'
import { Message } from 'element-ui'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://129.28.147.182:9401',
   //baseURL: 'http://10.100.0.206:20021',//线上地址prod-api
   baseURL: process.env.NODE_ENV === "production" ? "/prod-api" : "/",
  // baseURL: 'http://182.140.209.211:20021',//线上地址
  // baseURL: 'http://10.100.0.210:9080',//后端测试地址
  // baseURL: 'http://192.168.255.18:20021', //后端本地地址
  // baseURL: 'http://192.168.255.26:20021', //后端本地地址
  // baseURL: 'http://192.168.255.10:20021', //后端本地地址
   //baseURL: 'http://127.0.0.1:20021', //后端本地地址
  //baseURL: 'http://www.hanyuan.gov.cn/zwmap', //线上地址
  // 超时
  timeout: 20000
})

service.interceptors.response.use(
  response => {
  // 这里的config包含每次请求的内容
  const token = localStorage.getItem('token')
  if (token ) {
    // 添加headers
    response.headers.token = token
  }
    return response
  },
  error => {
    console.log(error, 'error')
  })
export default service

